
mapboxgl.accessToken = 'pk.eyJ1Ijoic29uaWFjb3NtZSIsImEiOiJjbWlwc21ubDgwNmZtM2tyMWIzb2Ridmp1In0.HV7anOiaxIO_VNElv15czg';

let map;
const markers = [];
const creches = document.querySelectorAll('.card-creche');
const filters = document.querySelectorAll('.js-map-filter');
const initialCoords = [-0.5906327, 44.8567189];
const initialZoom = 9;

function handleError(err) {
	console.log('ohhh noooo');
	console.log(err);
}

async function fetchCreches() {
	const data = {
		action: "eponyme_get_creches",
		nonce: my_ajax_object.nonce,
	};
	const res = await fetch(my_ajax_object.ajax_url, {
		method: 'POST',
		body: new URLSearchParams(data),
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'Cache-Control': 'no-cache',
		},
	});
	const locations = await res.json();
	return locations.data;
}

async function addMarkers() {

	// Clear existing markers
	markers.forEach((marker) => marker.remove());
	const locations = await fetchCreches().catch(handleError);

	locations.features.forEach((store, index) => {

		// Create marker element
		const el = document.createElement('div');
		el.id = `marker-${index}`;
		el.className = `marker all ${store.properties.terms}`;
		el.setAttribute('aria-label', store.properties.name);
		el.dataset.storeIndex = index;

		// Create Mapbox marker with proper anchoring
		const marker = new mapboxgl.Marker({
			element: el,
			anchor: 'bottom'
		})
			.setLngLat(store.geometry.coordinates)
			.addTo(map);

		markers.push(marker);

		// Add click event
		el.addEventListener('click', (e) => {
			e.stopPropagation();
			selectStore(index, store.geometry.coordinates);
		});

	});
}

/**
* Fly to a store location on the map
*/
function flyToStore(coordinates) {
	map.flyTo({
		center: coordinates,
		zoom: 10,
		duration: 1000
	});
}

function resetFly() {
	map.flyTo({
		center: initialCoords,
		zoom: initialZoom,
		duration: 1000
	});
}

function resetActivesElt() {
	const activeItems = document.querySelectorAll('.card-creche.active');
	activeItems.forEach((item) => item.classList.remove('active'));
	const activeMarkers = document.querySelectorAll('.marker.active');
	activeMarkers.forEach((marker) => marker.classList.remove('active'));
}

function selectStore(index, coordsArray) {

	const activeItems = document.querySelectorAll('.card-creche.active');
	activeItems.forEach((item) => item.classList.remove('active'));

	// Add active state to selected item
	const selectedListing = document.getElementById(`creche-${index}`);
	if (selectedListing) {
		selectedListing.classList.add('active');
		selectedListing.scrollIntoView({
			behavior: 'smooth',
			block: 'nearest'
		});
	}

	// Update markers - remove previous active state
	const activeMarkers = document.querySelectorAll('.marker.active');
	activeMarkers.forEach((marker) => marker.classList.remove('active'));

	// Add active state to selected marker
	const selectedMarker = document.getElementById(`marker-${index}`);
	if (selectedMarker) {
		selectedMarker.classList.add('active');
	}

	flyToStore(coordsArray);
}

async function initMap() {
	map = new mapboxgl.Map({
		container: 'map',
		style: 'mapbox://styles/mapbox/standard',
		config: {
			basemap: {
				colorTrunks: "#307fb0",
				colorRoads: "#80a0b4",
				theme: "faded",
				colorGreenspace: "#cfe7d8",
				colorWater: "#d5e5f7",
				showPedestrianRoads: false,
				showPointOfInterestLabels: false,
				showRoadLabels: true,
				showTransitLabels: false,
				showAdminBoundaries: false,
				show3dObjects: false,
				showLandmarkIconLabels: false,
			}
		},
		center: initialCoords,
		zoom: initialZoom,
		scrollZoom: false,
		boxZoom: false,
		dragRotate: false,
		renderWorldCopies: false
	});

	map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

	map.on('load', () => {
		console.log('Map loaded');
		addMarkers();
	});
}


function togglePressAttribute(newFilter) {
	const oldCurrent = document.querySelector(`.js-map-filter[aria-pressed='true']`);
	console.log(oldCurrent);
	if (oldCurrent) {
		oldCurrent.setAttribute('aria-pressed', false);
	}
	newFilter.setAttribute('aria-pressed', true);
}

function updateListing(type) {

	creches.forEach((elt) => {
		if (elt.classList.contains(type)) {
			elt.removeAttribute('hidden');
		} else {
			elt.setAttribute('hidden', true);
		}
	});
}

function updateMarkers(type) {
	const markers = document.querySelectorAll('.marker');
	markers.forEach((elt) => {
		if (elt.classList.contains(type)) {
			elt.removeAttribute('hidden');
		} else {
			elt.setAttribute('hidden', true);
		}
	});
}

function handleFilterClick() {
	const clickedButton = this;
	const type = clickedButton.dataset.filter;
	if (clickedButton.getAttribute('aria-pressed') == "true")
		return;

	togglePressAttribute(clickedButton);
	updateListing(type);
	updateMarkers(type);
}

function handleCrecheClick() {
	const creche = this;
	const coords = [];
	coords.push(creche.dataset.longitude);
	coords.push(creche.dataset.latitude);

	selectStore(creche.dataset.index, coords);
}

filters.forEach((elt) => {
	elt.addEventListener('click', handleFilterClick);
});


initMap();
